import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from '../../core/authentication/auth.service';
import { Subscription, timer, from } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {

  enabledButton: boolean = true;
  constructor(private authService: AuthService, private spinner: NgxSpinnerService) {}

  login() {
    if(this.enabledButton) {
      this.spinner.show();
      this.authService.startSigninMainWindow();
      this.enabledButton = false;
      setTimeout(() => {
        this.enabledButton = true;
      }, 3000);
    }    
  }
}


